export default function clearCart() {
  return (dispatch) => {
    delete localStorage.cart;
    dispatch({ type: "CART_RESET" });
  };
}
